// src/components/Contact.tsx

import { useRef } from "react";

import emailjs from "@emailjs/browser";

import {
  MapPin,
  Phone,
  Mail,
} from "lucide-react";

// import {
//   FaFacebookF,
//   FaInstagram,
//   FaLinkedinIn,
//   FaTwitter,
// } from "react-icons/fa";

import "../styles/contact.css";

const Contact = () => {

  const form = useRef<HTMLFormElement>(null);

  const sendEmail = (
    e: React.FormEvent
  ) => {

    e.preventDefault();

    if (!form.current) return;

    emailjs.sendForm(
      "service_mwmvtag",
      "template_k0ppbek",
      form.current,
      "PsOu4S683CeMuEh-k"
    )
    .then(() => {

      alert("Message sent successfully!");

      form.current?.reset();

    })
    .catch((error) => {

      console.log(error);

      alert("Failed to send message.");

    });

  };

  return (
    <section id="contact" className="contact">

      {/* HEADER */}

      <div className="contact-header">

        <span>CONTACT US</span>

        <h2>
          Let's Build The Future
          <br />
          Of Smart Nutrition
        </h2>

        <p>
          Reach out to Dagda Nutrition for partnerships,
          vending deployment, demos or collaboration.
        </p>

      </div>

      {/* CONTACT WRAPPER */}

      <div className="contact-wrapper">

        {/* LEFT FORM */}

        <div className="contact-form-card">

          <div className="contact-glow"></div>

          <form
            ref={form}
            onSubmit={sendEmail}
            className="contact-form"
          >

            <input
              type="text"
              name="user_name"
              placeholder="Your Name"
              required
            />

            <input
              type="email"
              name="user_email"
              placeholder="Your Email"
              required
            />

            <input
              type="text"
              name="subject"
              placeholder="Subject"
              required
            />

            <textarea
              name="message"
              placeholder="Your Message"
              required
            ></textarea>

            <button type="submit">
              Send Message
            </button>

          </form>

        </div>

        {/* RIGHT INFO */}

        <div className="contact-info">

          <span className="mini-contact-tag">
            GET IN TOUCH
          </span>

          <h3>
            Smart Protein
            Starts Here
          </h3>

          <p>
            Connect with Dagda Nutrition to deploy
            intelligent protein vending solutions
            for gyms, offices, campuses and
            wellness environments.
          </p>

          {/* INFO GRID */}

          <div className="contact-info-grid">

            <div className="info-box">

              <div className="info-icon">
                <MapPin size={20} />
              </div>

              <div>
                <h4>Head Office</h4>
                <p>Dublin, Ireland</p>
              </div>

            </div>

            <div className="info-box">

              <div className="info-icon">
                <Phone size={20} />
              </div>

              <div>
                <h4>Call Support</h4>
                <p>+353 89 2753452</p>
              </div>

            </div>

            <div className="info-box">

              <div className="info-icon">
                <Mail size={20} />
              </div>

              <div>
                <h4>Email Us</h4>
                <p>hello@dagdanutrition.com</p>
              </div>

            </div>

          </div>

          {/* SOCIALS */}

          {/* <div className="social-section">

            <h5>Follow Us</h5>

            <div className="social-icons">

              <a href="/">
                <FaFacebookF />
              </a>

              <a href="/">
                <FaTwitter />
              </a>

              <a href="/">
                <FaInstagram />
              </a>

              <a href="/">
                <FaLinkedinIn />
              </a>

            </div>

          </div> */}

        </div>

      </div>

      {/* MAP */}

      <div className="map-section">

        <iframe
          title="map"
          src="https://maps.google.com/maps?q=Dublin%20Ireland&t=&z=12&ie=UTF8&iwloc=&output=embed"
          loading="lazy"
        ></iframe>

      </div>

    </section>
  );
};

export default Contact;